import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import * as z from "zod";
import { Button } from "../../../../components/ui/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "../../../../components/ui/form";
import { Textarea } from "../../../ui/textarea";
import { toast } from "../../../../hooks/use-toast";

const formSchema = z.object({
  details: z
    .string()
    .min(1, "details is required")
    .min(3, "details atleast 20 characters")
    .max(200, "details should be at most 200 characters"),
});

const AddMembershipDetails = ({ initialData, onSave, onClose }) => {
  const form = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      details: "",
    },
  });

  useEffect(() => {
    if (initialData) {
      form.reset(initialData);
    }
  }, [initialData, form]);

  const isFormValid = () => {
    const values = form.getValues();
    const hasValues = values.details?.trim().length > 0;

    if (initialData) {
      return hasValues && values.details !== initialData.details;
    }
    return hasValues;
  };

  const onSubmit = (data) => {
    try {
      onSave(data);
      toast({
        title: "Success",
        description: initialData
          ? "Membership details updated successfully"
          : "Membership details saved successfully",
      });
      onClose();
      // eslint-disable-next-line
    } catch (error) {
      toast({
        variant: "destructive",
        title: "Error",
        description: "Failed to save membership details",
      });
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-3xl max-h-[80vh] overflow-y-auto">
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="border border-solid border-border p-4 rounded-lg">
              <div className="grid grid-cols-1 gap-6">
                <FormField
                  control={form.control}
                  name="details"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel className="text-gray-800">
                        If you have any membership then enter its detail
                      </FormLabel>
                      <FormControl>
                        <Textarea
                          {...field}
                          placeholder="Write detail here..."
                          className="min-h-[150px]"
                        />
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />

                <div className="flex justify-end gap-4">
                  <Button variant="secondary" type="button" onClick={onClose}>
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    type="submit"
                    disabled={!isFormValid()}
                  >
                    {initialData ? "Update" : "Save"} Membership
                  </Button>
                </div>
              </div>
            </div>
          </form>
        </Form>
      </div>
    </div>
  );
};
export default AddMembershipDetails;
